import styled from "styled-components";

import { faAngleDown, faAngleUp, faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormElementError } from "components/organisms/form/Form";
import { TextFieldClean } from "components/organisms/form/TextField";
import { IndexTerm } from "pages/Productadmin/ProductPage/EditProductPage";

export function ProduktTerms(props: { terms: IndexTerm[]; setTerms: (indexes: IndexTerm[]) => void; formErrors: FormElementError<unknown> }) {
	const { terms, setTerms, formErrors } = props;

	function changeTermsPosition(newIndex: number, currentIndex: number) {
		const termsCopy = [...terms];
		const tempElement = termsCopy[newIndex];
		termsCopy[newIndex] = termsCopy[currentIndex];
		termsCopy[currentIndex] = tempElement;
		setTerms(termsCopy);
	}

	return (
		<>
			{(terms?.length && (
				<label>
					Vilkår
					<TermsWrapper>
						{terms.map((t: IndexTerm, i: number) => {
							return (
								<TermDragAndSortingWrapper key={`${t.index}-${t.tekst?.slice(0, 29)}`}>
									<SortingButtonsContainer>
										<button
											style={{ gridRow: "1" }}
											type="button"
											className="noStyle"
											onClick={() => changeTermsPosition(i - 1, i)}
											disabled={i === 0}
										>
											{i === 0 ? "" : <FontAwesomeIcon icon={faAngleUp} />}
										</button>

										<button
											style={{ gridRow: "2" }}
											type="button"
											className="noStyle"
											onClick={() => changeTermsPosition(i + 1, i)}
											disabled={i === terms.length - 1}
										>
											{i === terms.length - 1 ? "" : <FontAwesomeIcon icon={faAngleDown} />}
										</button>
									</SortingButtonsContainer>
									<TextFieldClean
										key={t.index}
										index={i}
										name="terms[]"
										defaultValue={t?.tekst}
										onDelete={() => {
											const newTerms = [...terms];
											newTerms.splice(i, 1);
											setTerms(newTerms);
										}}
										formErrors={formErrors as FormElementError<unknown>}
									/>
								</TermDragAndSortingWrapper>
							);
						})}
					</TermsWrapper>
				</label>
			)) || <>Ingen vilkår</>}
			<AddNewButton
				type="button"
				onClick={() => {
					if (terms?.length) {
						setTerms([...terms, { tekst: "", index: terms[terms.length - 1]?.index + 1 }]);
					} else {
						setTerms([{ tekst: "", index: 0 }]);
					}
				}}
			>
				<FontAwesomeIcon icon={faPlusCircle} />
				Legg til nytt vilkår
			</AddNewButton>
		</>
	);
}

const AddNewButton = styled.button`
	width: max-content;
	color: var(--nte-blaa-uu);
	background: none;
	padding: 0.2rem 1rem;
	display: flex;
	gap: 0.5rem;
	justify-content: center;
	border: none;
	align-items: center;
	svg {
		font-size: 1.3rem;
	}
	:hover {
		color: var(--nte-blaa-uu);
		background: none;
		opacity: 0.9;
	}
`;

const TermsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

const TermDragAndSortingWrapper = styled.div`
	display: flex;
`;
const SortingButtonsContainer = styled.div`
	display: grid;
	grid-template-rows: 1fr 1fr;
	button {
		font-size: 1rem;
		padding: 0 0.5rem;
		color: var(--nte-blaa-uu);
	}
`;
